module.exports = {
    title: "Duration",
    crud: {
        create: "Create Duration",
        edit: "Edit Duration",
        view: "View Duration",
    },
    table: {
        title: "Title",
    },
    form: {
        title: "Title",
        noOfTitle: "No.",
    },
    validation: {
        required: {
            title: 'Title is required',
            noOfTitle: 'No of title is required',
        },
        minLength: {
            title: 'title must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}
